import React, { FC } from 'react';

import classNames from 'classnames';

import cls from './Checkbox.module.css';

interface CheckboxProps {
    title?: string;
    isActive: boolean;
    onClick?: () => void;
    isDisabled?: boolean;
    children?: React.ReactNode;
    classes?: string;
    checkBoxClassName?: string;
    activeCheckedIconColor?: string;
}

export const Checkbox: FC<CheckboxProps> = ({
    title,
    isActive,
    onClick,
    isDisabled = false,
    children,
    classes,
    checkBoxClassName,
    activeCheckedIconColor = '#252733',
}) => (
    <div
        onClick={!isDisabled ? onClick : undefined}
        className={classNames(cls.wrapper, [classes], { [cls.disabled]: isDisabled })}
    >
        <div className={classNames(cls.customCheckbox, checkBoxClassName)}>
            <input
                type="checkbox"
                name="checkbox"
                checked={isActive}
                readOnly
                disabled={isDisabled}
                className={cls.checkboxInput}
            />
            {isActive && (
                <>
                    {isDisabled ? (
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M12.4084 5.28037L6.76822 12.0486L3 8.90841L4.28037 7.37196L6.51215 9.23178L10.872 4L12.4084 5.28037Z"
                                fill="#F5F5F5"
                            />
                        </svg>
                    ) : (
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M12.3839 5.32012L7.0638 11.7042L3.67969 8.88413L4.31987 8.11591L6.93576 10.2958L11.6157 4.67993L12.3839 5.32012Z"
                                fill={activeCheckedIconColor}
                            />
                        </svg>
                    )}
                </>
            )}
        </div>
        {title && <span className={cls.title}>{title}</span>}
        {children}
    </div>
);
